import React from 'react';
import { buildSmoothSvgPath } from '../boardSmoothPath.js';

export const BoardMapDrawingsLayer = ({
  drawings,
  selectedDrawingId,
  selectedDrawingIds = [],
  onSelectDrawing,
  onDrawingPointerDown,
  canvasWidth,
  canvasHeight,
  drawingDraftPoints = [],
  offsetX = 0,
  offsetY = 0,
  getDrawingNodeId,
}) => (
  <svg
    className='absolute inset-0'
    width={canvasWidth}
    height={canvasHeight}
    viewBox={`0 0 ${canvasWidth} ${canvasHeight}`}
    preserveAspectRatio='none'
    style={{ zIndex: 15, pointerEvents: 'none' }}
  >
    <g transform={`translate(${offsetX} ${offsetY})`}>
      {Array.isArray(drawingDraftPoints) && drawingDraftPoints.length >= 2 && (
        <path
          d={buildSmoothSvgPath(drawingDraftPoints)}
          fill='none'
          stroke='rgb(var(--secondary))'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeOpacity='0.95'
          pointerEvents='none'
        />
      )}
      {drawings.map(drawing => {
      if (drawing?.type !== 'path' || !Array.isArray(drawing?.points) || drawing.points.length < 2) {
        return null;
      }
      const isSelected =
        selectedDrawingId === drawing.id || selectedDrawingIds.includes(drawing.id);
      const d = buildSmoothSvgPath(drawing.points);
      return (
        <path
          key={drawing.id}
          data-map-drawing-root='true'
          data-map-node-id={getDrawingNodeId?.(drawing.id) || undefined}
          d={d}
          fill='none'
          stroke={`rgb(var(--${isSelected ? 'secondary' : drawing?.stroke || 'contrast'}))`}
          strokeWidth={
            isSelected
              ? Math.max(4, Number(drawing?.strokeWidth) || 0)
              : Number(drawing?.strokeWidth) || 2
          }
          strokeDasharray={drawing?.strokeDasharray || undefined}
          strokeLinecap='round'
          strokeLinejoin='round'
          pointerEvents='stroke'
          onPointerDown={event => {
            event.stopPropagation();
            onDrawingPointerDown?.(event, drawing.id);
          }}
          onClick={event => {
            event.stopPropagation();
            onSelectDrawing?.(drawing.id);
          }}
        />
      );
      })}
    </g>
  </svg>
);
